const checkConvertSizeError = (body) => {
  // if all request options are set, then we can assume that the error is not due to a missing backend
  try {
    const data = JSON.parse(body);
    const hasEmptyOptions = [
      'from_brand',
      'from_gender',
      'from_unit',
      'product_type',
      'size',
      'to_brand',
      'to_gender',
      'to_unit',
    ].some((key) => {
      return data[key] === undefined || data[key] === null || data[key] === '';
    });
    return !hasEmptyOptions;
  } catch {
    return false;
  }
};

const checkFitFeedbackForUserError = (error, data) => {
  // if we have a PT slug then we have everything we need to make this request
  // if it fails, it is because the user has not created a fit feedback for this product,
  // which returns with code 5, and is not an error we need to send to bugsnag
  // Reference: https://grpc.github.io/grpc/core/md_doc_statuscodes.html
  const ptSlug = data?.url?.split('productTemplateSlug=')?.[1];

  if (ptSlug && error?.response?.data?.code === 5) {
    return true;
  }

  return false;
};

const checkIncorrectLoginInfo = ({ error, options }) => {
  // do not log incorrect username/pw to bugsnag
  const hasUsernameAndPassword = options.data?.username && options.data?.password;
  const incorrectLoginInfo =
    error?.response?.status === 422 &&
    error?.response?.data?.messages?.[0]
      ?.toLowerCase()
      ?.includes('your login information is not correct');

  return !!(hasUsernameAndPassword && incorrectLoginInfo);
};

export const isKnownBackendError = ({ url, options, error, forceViceroy }) => {
  if (url === '/web-api/v1/login') {
    if (forceViceroy) return false;
    return checkIncorrectLoginInfo({ error, options, forceViceroy });
  }

  // error message has been passed to the server
  const errorMessage = error?.response?.data?.messages;
  if (errorMessage?.length > 0) {
    return true;
  }

  if (url === '/web-api/v1/convert_size') {
    return checkConvertSizeError(options.data);
  }

  if (url === '/web-api/fit-feedback/get-fit-feedback-for-user') {
    return checkFitFeedbackForUserError(error, options);
  }

  return false;
};
